import { render } from "./MpAprobado.vue?vue&type=template&id=462bca00"
import script from "./MpAprobado.vue?vue&type=script&lang=js"
export * from "./MpAprobado.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__